import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";

export abstract class AtgardBaseCommand extends BasicCommand<AtgardBaseCommand> {
    atgardGuid: string;
    kontraktGuid: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "atgard";

    get primaryKey(): IAtgardPrimaryKey {
        return {
            atgardGuid: this.atgardGuid,
            kontraktGuid: this.kontraktGuid
        };
    }
    constructor($type, commandType) {
        super($type, AtgardBaseCommand.$groupKey, commandType);
    }
}

export interface IAtgardPrimaryKey extends IPrimaryKey<IAtgardPrimaryKey> {
    atgardGuid: string;
    kontraktGuid: string;
}
